// @flow

import React from "react";
import { localize } from "redux-i18n";

import { Button, SectionItems, SectionItem } from "@components";
import { formatDateTime } from "@transformers/date";
import type { SelectedTask } from "@modules/reporting/reducer/tasks/types";

type OwnProps = $Exact<{
  selectedTask: SelectedTask,
}>;

type Props = $Exact<{
  ...PropsFromLocalize,
  ...OwnProps,
}>;

export const RTWTaskDetailsView = (props: Props) => (
  <SectionItems cols={2}>
    <SectionItem
      label={props.t("ACTION_ID")}
      value={props.selectedTask.id || props.t("N/A")}
      border
    />
    <SectionItem
      label={props.t("EMPLOYEE_NAME")}
      value={props.selectedTask.employee.name || props.t("N/A")}
      border
    />
    <SectionItem
      label={props.t("DEPARTMENT")}
      value={props.selectedTask.organisationalUnits.map(ou => ou.name).join(", ") || props.t("N/A")}
      border
    />
    {props.selectedTask.isOverdue ? (
      <SectionItem
        label={props.t("OVERDUE")}
        value={
          <div className="text-pumpkin-orange font-weight-bold">
            {props.selectedTask.dueDate
              ? formatDateTime(props.selectedTask.dueDate)
              : props.t("N/A")}
          </div>
        }
        border
      />
    ) : (
      <SectionItem
        label={props.t("OVERDUE")}
        value={
          props.selectedTask.dueDate ? formatDateTime(props.selectedTask.dueDate) : props.t("N/A")
        }
        border
      />
    )}
    <SectionItem
      label={props.t("ABSENCE_START")}
      value={
        props.selectedTask.absenceStart
          ? formatDateTime(props.selectedTask.absenceStart)
          : props.t("N/A")
      }
      border
    />
    <SectionItem
      label={props.t("RTW_DATE")}
      value={
        props.selectedTask.rtwDate ? formatDateTime(props.selectedTask.rtwDate) : props.t("N/A")
      }
      border
    />
    <SectionItem
      label={props.t("DAYS_LOST")}
      value={props.selectedTask.daysLost || props.t("N/A")}
      border
    />
    <SectionItem
      label={props.t("ABSENCE_REASON")}
      value={(props.selectedTask.absenceReason || {}).name || props.t("CONSENT_WITHHELD")}
      border
      rightAction={
        (props.selectedTask || {}).managerCanChangeReason ? (
          <Button materialIcon="edit" size="small">
            {props.t("EDIT")}
          </Button>
        ) : null
      }
    />
  </SectionItems>
);

export default localize()(RTWTaskDetailsView);
